/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ModalityCheckoutResponseDto
 */
export interface ModalityCheckoutResponseDto {
    /**
     * Stripe checkout session URL
     * @type {string}
     * @memberof ModalityCheckoutResponseDto
     */
    url: string;
}

/**
 * Check if a given object implements the ModalityCheckoutResponseDto interface.
 */
export function instanceOfModalityCheckoutResponseDto(value: object): value is ModalityCheckoutResponseDto {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function ModalityCheckoutResponseDtoFromJSON(json: any): ModalityCheckoutResponseDto {
    return ModalityCheckoutResponseDtoFromJSONTyped(json, false);
}

export function ModalityCheckoutResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModalityCheckoutResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function ModalityCheckoutResponseDtoToJSON(json: any): ModalityCheckoutResponseDto {
    return ModalityCheckoutResponseDtoToJSONTyped(json, false);
}

export function ModalityCheckoutResponseDtoToJSONTyped(value?: ModalityCheckoutResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
    };
}

